import React, {useState, useEffect} from 'react';
import { classNames } from '../../Services/helpers';
import {ReactComponent as SolidTriangle} from '../../Icons/Solid/triangle.svg';

const TheTooltip = ({content, show, hide, watch, above, below, left, right}) => {
    const [toggled, setToggled] = useState(false);

    useEffect(() => {
        if (!watch || !watch.current) {
            return;
        }

        watch.current.addEventListener('mouseenter', () => {
            setToggled(true);
        });
        watch.current.addEventListener('mouseleave', () => {
            setToggled(false);
        });
    }, [watch])

    return <div class={classNames(
            toggled ? 'visible opacity-100' : 'invisible opacity-0',
            'absolute whitespace-normal break-words rounded-lg p-2 shadow-lg isolate z-50 font-normal text-xs',
            'bg-slate-100 text-slate-700 fill-slate-700 border border-slate-300',
            'transition-opacity duration-300',
            above && 'bottom-12',
            below && 'top-12',
            left && 'right-12',
            right && 'left-12',
        )}
        onClick={() => hide && hide()}
    >
        {content}

        <Arrow {...{above, below, left, right}} />
    </div>
}

const Arrow = ({above, below, left, right}) => {
    return <div class={classNames(
        'absolute w-4 h-4',
        below && '-top-4 left-[50%] transform -translate-x-2 mt-px',
        above && '-bottom-4 left-[50%] transform -translate-x-2',
        left && '-right-4 top-[50%] transform -translate-y-2',
        right && '-left-4 top-[50%] transform -translate-y-2',
    )}
        // style={{left: '50%', transform: 'translateX(-50%)'}}
    >
        <SolidTriangle class="w-full h-full fill-slate-300" />
    </div>
}

export default TheTooltip;